import { Text } from '@fluentui/react';

import { ITextProps } from '@fluentui/react';

export interface IDateTimeDisplayProps extends ITextProps {
    timestamp: string;
    format: 'ShortDateOrTime' | 'LocaleDate' | 'LocaleDateTime';
}

export const DateTimeDisplay = (props: IDateTimeDisplayProps) => {
    const dateToFormat = new Date(Date.parse(props.timestamp));
    let displayString = dateToFormat.toLocaleDateString();

    if (props.format === 'ShortDateOrTime') {
        const nowLocaleDateString = new Date().toLocaleDateString();
        //if the locale date string is the same as today's date, show the time only
        if (displayString === nowLocaleDateString) {
            //get the hour, minute and AM/PM only
            displayString = dateToFormat.toLocaleTimeString(undefined, { hour: 'numeric', minute: 'numeric' });
        } else {
            //otherwise, show the day and month only
            displayString = dateToFormat.toLocaleDateString(undefined, { day: 'numeric', month: 'numeric' });
        }
    } else if (props.format === 'LocaleDateTime') {
        displayString = dateToFormat.toLocaleString();
    }

    return <Text {...props}>{displayString}</Text>;
};
